/** Shared SSE line parser for ``data:`` JSON events (double-newline framed). */

export function consumeSseDataLines<T>(
  buffer: string,
  onPayload: (payload: string) => T | null,
): { remainder: string; events: T[] } {
  const events: T[] = [];
  const blocks = buffer.split("\n\n");
  const remainder = blocks.pop() ?? "";
  for (const block of blocks) {
    for (const line of block.split("\n")) {
      if (!line.startsWith("data:")) {
        continue;
      }
      const payload = line.slice(5).trimStart();
      const event = onPayload(payload);
      if (event) {
        events.push(event);
      }
    }
  }
  return { remainder, events };
}

export async function readSseStream<T>(
  body: ReadableStream<Uint8Array>,
  parsePayload: (raw: string) => T | null,
  onEvent: (event: T) => void,
  signal: AbortSignal,
): Promise<void> {
  const reader = body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";

  try {
    while (true) {
      const { done, value } = await reader.read();
      if (done) {
        break;
      }
      buffer += decoder.decode(value, { stream: true });
      const parsed = consumeSseDataLines(buffer, parsePayload);
      buffer = parsed.remainder;
      for (const event of parsed.events) {
        onEvent(event);
      }
    }
  } catch (error) {
    if (signal.aborted) {
      return;
    }
    throw error;
  }
}
